export const setVariableToLS = (key: string, value) => {
    localStorage.setItem(key, JSON.stringify(value));
}

export const getVariableFromLS = (key:string) => {
    return JSON.parse(localStorage.getItem(key) ?? '{}');
}